
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/synapse",
      function () {
        return require("private-next-pages/synapse/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/synapse"])
      });
    }
  